import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useFormik } from 'formik';
import * as yup from 'yup';
import './Form.css';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { FormValues, Employee } from '../../interfaces';

type Props = {
  formValues: FormValues;
  setFormValues: any;
  employee: Employee;
  nextStep: () => void;
};

const validationSchema = yup.object({
  newCustomer: yup.string().required('Required'),
});

function NewCustomer({ formValues, setFormValues, employee, nextStep }: Props) {
  const artistName = employee.displayName
    ? employee.displayName
    : `${employee.user.firstName} ${employee.user.lastName}`;

  const questionValues = {
    header: `Have you got a tattoo from ${artistName} before?`,
    progress: 5,
  };

  const formik = useFormik({
    initialValues: {
      newCustomer: formValues.newCustomer,
    },
    validationSchema,
    validateOnMount: true,
    onSubmit: values => {
      setFormValues({
        ...formValues,
        ...values,
      });
      sessionStorage.setItem('newCustomer', values.newCustomer!);
      nextStep();
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Typography variant="h2" className="form-header">
        {questionValues.header}
      </Typography>
      <RadioGroup
        aria-labelledby="radio-newCustomer"
        name="newCustomer"
        value={formik.values.newCustomer}
        onChange={formik.handleChange}
        className="radio-box">
        <FormControlLabel
          value="false"
          control={<Radio className="radio-input" />}
          label="Yes"
          className={`radio-pill ${
            formik.values.newCustomer === 'false' ? 'checked' : ''
          }`}
        />
        <FormControlLabel
          value="true"
          control={<Radio className="radio-input" />}
          label="No"
          className={`radio-pill ${
            formik.values.newCustomer === 'true' ? 'checked' : ''
          }`}
        />
      </RadioGroup>
      {formik.touched.newCustomer && formik.errors.newCustomer && (
        <FormHelperText>{formik.errors.newCustomer}</FormHelperText>
      )}
      <Button
        variant="contained"
        className={`next ${formik.isValid ? 'done' : ''}`}
        type="submit">
        Next
      </Button>
    </form>
  );
}

export default NewCustomer;
